import { HorizontalPlotter } from "./horizontalPlotter";
import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType } from "../../definitions";
import { DataProperty, THIRD_ABSOLUTE_SORT } from "../../library/constants";

export class AbsolutePlotter extends HorizontalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    protected getPlotDefinition(): PlotDefinition {
        let plotDefinition: PlotDefinition;
        plotDefinition = this.getBlankPlotDefinition(1);
        this.addAbsoluteDifferenceColumns(plotDefinition, ChartType.AbsoluteChart);
        return plotDefinition;
    }

    protected getDataProperty(): DataProperty {
        return DataProperty.AbsoluteDifference;
    }
}
